import PropTypes from 'prop-types';
import React from 'react';

export default function ChevronDown({
  width = '100%',
  height = '100%',
  color = 'currentColor',
  flipped = false,
  strokeWidth = '3',
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 27.8 16"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      style={{
        transform: flipped ? 'scaleY(-1)' : undefined,
      }}
    >
      <polyline
        style={{
          stroke: color,
          fill: 'none',
          strokeWidth,
          strokeLinecap: 'round',
          strokeMiterlimit: '10',
        }}
        points="26.3,1.5 13.9,13.9 1.5,1.5"
      />
    </svg>
  );
}

ChevronDown.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string,
  flipped: PropTypes.bool,
  strokeWidth: PropTypes.string,
};
